export function calcLogTime(startTime, endTime) {
  if (!startTime || !endTime) return 0;
  const [sh, sm] = startTime.split(':').map(Number);
  const [eh, em] = endTime.split(':').map(Number);
  const diffMin = (eh * 60 + em) - (sh * 60 + sm);
  if (diffMin <= 0) return 0;
  return Math.round(diffMin / 6) / 10; // tenths of an hour
}

export function calcSimTime(hobbsStart, hobbsStop) {
  const diff = Math.round((parseFloat(hobbsStop) - parseFloat(hobbsStart)) * 10) / 10;
  return diff > 0 ? diff : 0;
}

export function fmtDate(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${m}/${d}/${y}`;
}

export function fmtHours(h) {
  return Number(h).toFixed(1);
}

export function today() {
  return new Date().toISOString().split('T')[0];
}

export function monthRange() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  return {
    from: `${y}-${m}-01`,
    to: `${y}-${m}-${new Date(y, now.getMonth() + 1, 0).getDate()}`
  };
}
